import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Row extends Component {
  static propTypes = {
    gutters: PropTypes.bool,
    inner: PropTypes.bool,
    alignItems: PropTypes.string,
    alignContent: PropTypes.string,
    justifyContent: PropTypes.string,
    children: PropTypes.any
  }

  static defaultProps = {
    inner: false
  }

  render() {
    const { children, alignItems, justifyContent, alignContent, gutters, inner } = this.props
    const marginVer = inner ? 0 : 8
    const marginHor = 8

    let element = React.cloneElement(children, { margin: marginHor, gutters })

    if (Array.isArray(children)) {
      element = children.map((child, key) => React.cloneElement(child, { margin: marginHor, key, gutters }))
    }

    return (
      <div style={{
        display: 'flex',
        alignItems: alignItems || 'flex-start',
        justifyContent: justifyContent || 'flex-start',
        alignContent: alignContent || 'flex-start',
        margin: `${marginVer * 2}px ${gutters ? -marginHor : 0}px`
      }}
      >
        {element}
      </div>
    )
  }
}
